import { ActionButton } from '@library/components/buttons';
import { Float } from '@headlessui-float/react';
import { Popover } from '@headlessui/react';
import { cn as classNames } from '@library/component-utils/cn';

export const SelectPopoverContainer = ({
  buttonText,
  children,
  className = '',
  disabled = false,
  handleOnClick
}: {
  buttonText: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  handleOnClick: () => void;
}) => {
  const handleSave = (closeFn: () => void) => {
    handleOnClick();
    closeFn();
  };

  return (
    <Popover className={classNames('flex flex-col', className)}>
      {({ close, open }) => (
        <Float zIndex={9} placement="bottom-start" strategy="absolute">
          <Popover.Button
            className={classNames(
              open ? 'bg-soFresh-120' : 'bg-soFresh-110',
              'text-soClean-140 border-soFresh-140 hover:bg-soFresh-120 flex h-10 max-w-fit items-center justify-center whitespace-nowrap rounded-md border px-3 text-xs'
            )}
          >
            <span className="self-center pb-0.5">{buttonText}</span>
          </Popover.Button>

          <Popover.Panel className="!bg-soFresh-110 !border-soFresh-140 !text-soClean-140 font-heebo relative flex flex-col items-center justify-center gap-3 rounded-sm border p-3 text-sm">
            {children}
            <div className="flex justify-end gap-2">
              <ActionButton
                handleOnClick={() => close()}
                title="Cancel Change"
                variant="secondary"
              >
                Cancel
              </ActionButton>

              <ActionButton
                handleOnClick={() => handleSave(close)}
                title="Save Change"
                disabled={disabled}
                variant="primary"
              >
                Save
              </ActionButton>
            </div>
          </Popover.Panel>
        </Float>
      )}
    </Popover>
  );
};
